$(function() {
    // Empty inputs
    $(document).on('input blur', 'input, textarea', function() {
        $(this).toggleClass('empty', $(this).val() === '');
    });
    $('input, textarea').trigger('blur');
});